import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";

import { EntityType } from "@mapmycustomers/shared/enum";

import useMap from "@app/component/map/FeaturedMap/utils/useMap";
import { fetchHeatMapData } from "@app/scene/map/store/actions";
import HeatMapLayerData from "@app/scene/map/store/layers/heatMap/HeatMapLayerData";
import { getHeatMapLayerData, getMapViewport } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";
import MapViewportState from "@app/types/map/MapViewportState";
import isValidMapEntry from "@app/util/map/isValidMapEntry";

import gradient from "./util/gradient";

interface Props {
  data: HeatMapLayerData;
  fetchData: () => void;
  viewport: MapViewportState;
}

const HeatMapLayer: React.FC<Props> = ({ data, fetchData, viewport }) => {
  const { map } = useMap();
  const heatMapLayer = useRef(
    new google.maps.visualization.HeatmapLayer({
      gradient: ["transparent", ...gradient], // uses transparent color when weight is 0
      radius: 24,
    })
  );

  useEffect(() => {
    if (data.visible) {
      fetchData();
    }
  }, [fetchData, viewport, data.visible]);

  useEffect(() => {
    if (!data.visible) {
      return;
    }
    // heatMapLayer.current.setOptions({ maxIntensity: data.range.max });
    // heatMapLayer.current.setOptions({
    //   maxIntensity: data.pins.reduce(
    //     (sum, pin) => sum + (data.type === EntityType.DEAL ? pin.sumAmount ?? 0 : pin.count),
    //     0
    //   ),
    // });
    heatMapLayer.current.setMap(map);
    heatMapLayer.current.setData(
      data.pins
        .filter(
          (pin) =>
            isValidMapEntry(pin) &&
            (data.type === EntityType.DEAL ? pin.sumAmount ?? 0 : pin.count) > 0
        )
        .map((pin) => ({
          location: new google.maps.LatLng(pin.region!.latitude, pin.region!.longitude),
          weight: data.type === EntityType.DEAL ? pin.sumAmount ?? 0 : pin.count,
        }))
    );
    return () => {
      // we need this destructor when switching to other modes to remove
      // heat map from the map
      // eslint-disable-next-line react-hooks/exhaustive-deps
      heatMapLayer.current.setMap(null);
    };
  }, [data, map]);

  return null;
};

const mapStateToProps = (state: RootState) => ({
  data: getHeatMapLayerData(state),
  viewport: getMapViewport(state),
});

const mapDispatchToProps = {
  fetchData: fetchHeatMapData.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeatMapLayer);
